(ns common.schema.entities.workspace.kyc.contract-kyc-profile
  (:require
   [common.country :as country]
   [common.data-types :as data-types]
   [common.schema.entities.kyc.options :as kyc-options]
   [common.schema.option-filters :as option-filters]
   [common.schema.schema-utils :as su]))

(def schema
  (vec
   (concat
    (su/text-simple-field :contract-kyc-profile/name
                          "Name"
                          {:composite-attributes     [:contract-kyc-profile/target]
                           :name-attribute           :contract-kyc-profile/name
                           :calculation-triggers     {:entity.type/company [[:contract-kyc-profile/_target]]}
                           :editor-type              :editor.type/none
                           :default-field-visibility :in-use})

    (su/single-ref-field :contract-kyc-profile/target
                         "Target company"
                         [:entity.type/company]
                         {:mandatory-config         :mandatory/always
                          :system-required?         true
                          :system-semantics
                          su/user-provided-system-required-field-semantics
                          :default-field-visibility :in-use})

    (su/keyword-field :contract-kyc-profile/status
                      "Status"
                      kyc-options/status-options
                      {:default-field-visibility :in-use})

    (su/datetime-field :contract-kyc-profile/next-deadline
                       "Next deadline"
                       {:default-field-visibility :in-use})

    (su/datetime-field :contract-kyc-profile/approval-date
                       "Approval date"
                       {:default-field-visibility :in-use})

    (su/single-ref-field :contract-kyc-profile/our-kyc-contact
                         "Our KYC contact"
                         [:entity.type/account]
                         {:option-filter-fn         option-filters/active-users
                          :os-filter-terms-fn       (fn [_]
                                                      {"extras.active-user" true})
                          :default-field-visibility :in-use})

    (su/single-ref-field :contract-kyc-profile/their-kyc-contact
                         "Their KYC contact"
                         [:entity.type/person]
                         {:default-field-visibility :in-use})

    (su/keyword-field :contract-kyc-profile/kyc-country
                      "Jurisdiction"
                      country/options
                      {:default-field-visibility :in-use})

    (su/multi-ref-field :contract-kyc-profile/kyc-processes
                        "KYC processes"
                        [:entity.type/kyc-process]
                        {:editor-type              :editor.type/none
                         :grid-type                :editor.type/none
                         :filter-type              :filter.type/none
                         :default-field-visibility :in-use})

    (su/boolean-field :contract-kyc-profile/screening-enabled?
                      "Screening enabled?"
                      {:authorization              su/access-user-user
                       :not-clearable?             true
                       :default-field-visibility   :in-use
                       :in-use-for-this-data?      (fn [_ _ has-feature-access-fn _]
                                                     (has-feature-access-fn :feature/screening))
                       :hidden-from-configuration? true})

    (su/calculated-field :contract-kyc-profile/latest-process-status
                         "Latest process status"
                         {:default-field-visibility :in-use
                          :data-type                :data.type/keyword
                          :calculation-triggers     {:entity.type/kyc-process [[:contract-kyc-profile/_kyc-processes]]}
                          :composite-attrs          [:kyc-process/status :contract-kyc-profile/kyc-processes]
                          :calc-fn                  (fn [{:keys [entity-data entity-lookup]}]
                                                      (let [processes (get entity-data :contract-kyc-profile/kyc-processes)
                                                            latest-process (->> processes
                                                                                (keep entity-lookup)
                                                                                (remove :common/disabled?)
                                                                                (sort-by :common/created-on)
                                                                                (last))]
                                                        (:kyc-process/status latest-process)))})

    (su/calculated-field :contract-kyc-profile/latest-approved-ubo-count
                         "Number of UBOs"
                         {:data-type                :data.type/integer
                          :default-field-visibility :in-use
                          :composite-attrs          [:contract-kyc-profile/kyc-processes
                                                     :kyc-process/status
                                                     :kyc-process/answers]
                          :calculation-triggers     {:entity.type/kyc-process [[:contract-kyc-profile/_kyc-processes]]}
                          :calc-fn                  (fn [{:keys [entity-data entity-lookup]}]
                                                      (let [processes (get entity-data :contract-kyc-profile/kyc-processes)
                                                            latest-approved-process
                                                            (->> processes
                                                                 (keep entity-lookup)
                                                                 (remove :common/disabled?)
                                                                 (filter (fn [proc]
                                                                           (contains?
                                                                            #{:kyc-process.status/approved-modified
                                                                              :kyc-process.status/approved}
                                                                            (:kyc-process/status proc))))
                                                                 (sort-by :common/created-on)
                                                                 (last))
                                                            answers (:kyc-process/answers latest-approved-process)
                                                            answers (if (string? answers)
                                                                      (data-types/parse-edn-string answers)
                                                                      answers)
                                                            ubo-attribute (->> answers
                                                                               (keys)
                                                                               (some #{:contract-kyc/ubo-edn}))
                                                            ubo-data (get answers ubo-attribute)
                                                            ubo-data (if (string? ubo-data)
                                                                       (data-types/parse-edn-string ubo-data)
                                                                       ubo-data)]
                                                        (count ubo-data)))})

    (su/calculated-field :contract-kyc-profile/datetime-last-invitation
                         "Last invitation sent"
                         {:data-type                :data.type/datetime
                          :default-field-visibility :in-use
                          :composite-attrs          [:contract-kyc-profile/kyc-processes
                                                     :kyc-process/invited-date]
                          :calculation-triggers     {:entity.type/kyc-process [[:contract-kyc-profile/_kyc-processes]]}
                          :calc-fn                  (fn [{:keys [entity-data entity-lookup]}]
                                                      (let [processes (get entity-data :contract-kyc-profile/kyc-processes)
                                                            latest-invite-datetime (->> processes
                                                                                        (keep entity-lookup)
                                                                                        (remove :common/disabled?)
                                                                                        (keep :kyc-process/invited-date)
                                                                                        (sort)
                                                                                        (last))]
                                                        latest-invite-datetime))}))))
